import script from "./FlatMenuSidebar.vue?vue&type=script&setup=true&lang=js"
export * from "./FlatMenuSidebar.vue?vue&type=script&setup=true&lang=js"

import "./FlatMenuSidebar.vue?vue&type=style&index=0&id=4b91ecab&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b91ecab"]])

export default __exports__